import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import { apaMetadata, apaAsset } from '../../requests/loader';

/**
* @param pbi 
* @returns an api call response metadata and asset
*/
export const getProductTypes = async (plans: any) => {
    const region: string = DeviceStorage.getItem('region');
    const cardData: any = [];
    const data = plans.map(async (p: any) => {
        console.log('planes getProductTypes::::::', p);
        const [translations, assets] = await Promise.all([
            apaMetadata('', `SelectorDePlan_Tarjeta_${p.provider}`),
            apaAsset('', `SelectorDePlan_Tarjeta_${p.provider}`)
        ]);
        if (translations === undefined || assets === undefined || translations.error || assets.error) {
            return {}
        }
        return {
            translations,
            assets,
            id: p.id,
            onPlanClick: p.onPlanClick,
            price: p.planSelectorPrice.price,
            currency: p.planSelectorPrice.currency,
            isButtonVisible: p.isButtonVisible,
            buttonTextColorHex: p.buttonTextColorHex,
            buttonBGColorHex: p.buttonBGColorHex,
            productType: p.provider,
            family: p.family,
            offerid: p.offerid
        };
    });

    return new Promise((resolve, reject) => {
        Promise.all(data).then((response) => {
            response.map((i: any, index: number) => {
                if (i.translations !== undefined && i.assets !== undefined) {
                    const { assets, translations: { translations } } = i;
                    const addOn = JSON.parse(translations)
                    delete i.translations;
                    delete i.assets;
                    cardData.push({
                        ...i,
                        ...addOn.language[region],
                        imagenFondo_aaf: assets.ImagenFondo_aaf,
                        imagenLogo_aaf: assets.ImagenLogo_aaf,
                    });
                }
            });
        }).catch(error => {
            resolve({ cardData: [] });
        }).finally(() => {
            resolve({ cardData });
        });
    })
}



// WEBPACK FOOTER //
// ./src/payments/PlanSelector/PSUtils.ts